<template>
  <div>
    <div class="backdrop"></div>
    <dialog open>
      <div class="alpha">

        <div class="first-part">
          <img src="@/assets/wallet-icon-modal.svg" alt="wallet-icon-modal"/>
          <i class='bx bx-x' @click="$emit('close')"></i>
        </div>

        <div class="second-part">
          <p class="second-text-1">Create Wallet</p>
          <form @submit.prevent="create">

            <div class="input-form-2">
              <div class="input-form-3">
                <label>First Name</label>
                <input type="text" v-model="model.firstName"  placeholder="Enter First Name" class="input-form-1" required="required" />
              </div>
              <div class="input-form-3">
                <label>Last Name</label>
                <input type="text" v-model="model.lastName"  placeholder="Enter Last Name" class="input-form-1" required="required" />
              </div>
            </div>

            <div class="input-form-2">
              <div class="input-form-3">
                <label>Email</label>
                <input type="email" v-model="model.email"  placeholder="Enter Email Address" class="input-form-1" required="required" />
              </div>
              <div class="input-form-3">
                <label>BVN</label>
                <input type="number" v-model="model.bvn" placeholder="Enter BVN Number" class="input-form-1" required="required" />
              </div>
            </div>

            <div class="input-form-2">
              <div class="input-form-3">
                <label>Date of Birth</label>
                <input type="date" v-model="model.dob"  placeholder="Enter Date of Birth" class="input-form-1" required="required" />
              </div>
              <div class="input-form-3">
                <label>Phone number</label>
                <input type="number" v-model="model.phoneNumber" placeholder="Enter Phone Number" class="input-form-1" required="required" />
              </div>
            </div>

            <br/>
            <div class="separate">
<!--              <button class="btn">Back</button>-->
              <base-button :loading="loading">Create</base-button>
            </div>

          </form>
        </div>


      </div>

    </dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/baseComponents/buttons/BaseButton.vue";
import WalletRequest from "@/model/request/WalletRequest";
import {mapState} from "vuex";
import StoreUtils from "@/util/baseUtils/StoreUtils";


export default {
  name: "CreateWalletModal",
  components: {BaseButton},
  emits: ['close'],
  data() {
    return {
      model: new WalletRequest().create,
    };
  },
  computed:{
    ...mapState({
      loading: state => state.wallet.loading,
      auth: state => state.auth,
      userInfo: state => state.auth.userInfo,
    }),
  },
  methods:{
    async create() {
      await StoreUtils.dispatch(StoreUtils.actions.wallet.walletCreate, {
        bvn: this.model.bvn,
        dob: this.model.dob,
        email: this.model.email,
        firstName: this.model.firstName,
        lastName: this.model.lastName,
        phoneNumber: this.model.phoneNumber,
        countryCode: "234",
        currency: "NGN"
      });
      await StoreUtils.dispatch(StoreUtils.actions.wallet.walletReadWalletActivity,)
      await this.$emit('close');
    },
  },
}
</script>

<style scoped >

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
}


dialog {
  position: fixed;
  top: 15vh;
  width: 32rem;
  height: 20rem;
  left: calc(50% - 14rem);
  margin: 0;
  background-color: transparent;
  z-index: 100;
  border: none;
  animation: modal 0.3s ease-out forwards;
}

.alpha{
  position: relative;
  display: block;
  overflow: hidden;
  width: 578px;
  height: 510px;
  /*height: auto;*/
  padding: 24px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(3, 28, 67, 0.1);
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 34px 0 rgba(3, 28, 67, 0.13);
}

.first-part{
  display: flex;
  justify-content: space-between;
}

.bx-x{
  font-size: 25px;
  padding-top: 2px;
}

.separate{
  display: flex;
}

.btn{
  margin-right: 5%;
  align-items: center;
  /*padding: 10px 28px;*/
  gap: 8px;
  width: 570px;
  height: 48px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
}

.second-text-1{
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
  margin-top: 2%;
  margin-bottom: 4%;
}

.input-form-2{
  display: flex;
  justify-content: center;
  margin-top: 2%;
  margin-bottom: 2%;
}

.input-form-1{
  order: 1;
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  box-sizing: border-box;
  margin-bottom: 2%;
  margin-right: 2%;
  margin-left: 2%;
}

input {
  box-sizing: border-box;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  -webkit-transition: 0.3s;
  padding-top: 12px;
  padding-bottom: 12px;
  transition: 0.3s;
  outline: none;
  color: #667085;
  letter-spacing: 0.5px;
}

input:focus {
  border: 1px solid #24405A;
}


select {
  box-sizing: border-box;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  -webkit-transition: 0.3s;
  padding-top: 12px;
  padding-bottom: 12px;
  transition: 0.3s;
  outline: none;
  color: #667085;
  letter-spacing: 0.5px;
}

select:focus {
  border: 1px solid #24405A;
}

.input-form-3{
  width: 100%;
  margin-right: 1.5%;
  margin-left: 1.5%;
}

label{
  color: #667085;
  font-size: 15px;
}

@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 500px) {
  dialog {
    top: 5vh;
    width: 27rem;
    height: 20rem;
    left: calc(50% - 12.4rem);
    right: 30px;
  }
  h3{
    font-size: 20px;
  }
  p{
    font-size: unset;
  }
}
</style>